import { useEffect, useState } from 'react';
import Immutable from 'immutable';
import { Button } from 'edrolo-style-guide';
import GrokSelfReflection from '../../../GrokSelfReflection';
import QuestionSolution from '../../../QuestionSolution';
import WistiaUtils from 'edrolo/utils/WistiaUtils';
import { MultiSelector } from '../../../MultiSelector';
import styles from './styles.scss';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import questionTypePropInterface from '../../questionTypePropInterface';

export const MultiSelectQuestion = ({
  question,
  response,
  onSubmit,
  onSubmitGrok,
  grokkingItemIsSaving,
  onSubmitTeacherAnswer,
  isPrint,
}) => {
  const answers = question.get('answers');

  const [selectedAnswerIds, setSelectedAnswerIds] = useState(
    response ? response.get('select_multi_selected_answers') : Immutable.List()
  );

  // XXX: For some reason selectedAnswerIds isn't getting updated when
  // the response prop changes. This forces that to happen. I feel like
  // this shouldn't be necessary though.
  useEffect(() => {
    if (response) {
      setSelectedAnswerIds(response.get('select_multi_selected_answers'));
    } else {
      setSelectedAnswerIds(Immutable.List());
    }
  }, [response]);

  const handleChange = (answerId) => {
    if (
      selectedAnswerIds?.some(
        (selectedAnswerId) => selectedAnswerId === answerId
      )
    ) {
      const newSelectedAnswerIds = selectedAnswerIds.filter(
        (selectedAnswerId) => selectedAnswerId !== answerId
      );
      setSelectedAnswerIds(newSelectedAnswerIds);
    } else {
      setSelectedAnswerIds((prevSelectedAnswerIds) => [
        ...prevSelectedAnswerIds,
        answerId,
      ]);
    }
  };

  const handleSubmitResponse = () => {
    onSubmitTeacherAnswer
      ? onSubmitTeacherAnswer()
      : onSubmit({
          multiSelectedAnswerIds: selectedAnswerIds,
        });
  };

  return (
    <>
      {answers?.size ? (
        <MultiSelector
          disabled={!!response}
          answers={answers}
          correctAnswers={response && response.get('correct_answers')}
          selectedAnswerIds={selectedAnswerIds}
          isCorrect={response?.get('is_correct')}
          onChange={handleChange}
        />
      ) : null}

      {!response ? (
        <Button
          onClick={handleSubmitResponse}
          disabled={response && !selectedAnswerIds}
          data-test={`submit-${EXAM_QUESTION_TYPES.SELECT_MULTI}`}
        >
          {onSubmitTeacherAnswer ? 'View answer' : 'Save & continue'}
        </Button>
      ) : (
        <>
          <QuestionSolution
            headingText="Solution"
            questionId={question.get('id')}
            explanation={response.getIn(['solution', 'explanation'])}
            videoHash={response.getIn([
              'solution',
              'video',
              'wistia_hashed_id',
            ])}
            videoThumbnailUrl={WistiaUtils.getThumbnail(
              response.getIn(['solution', 'video'])
            )}
          />
          {!isPrint && (
            <GrokSelfReflection
              value={response.get('grokked')}
              onChange={onSubmitGrok}
              isSaving={grokkingItemIsSaving}
              className={styles.selfReflection}
            />
          )}
        </>
      )}
    </>
  );
};

MultiSelectQuestion.propTypes = {
  ...questionTypePropInterface,
};
